'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@lib/query/client';
import { useSupabaseClient } from '@lib/supabase/client';
import { uploadListingImportSource } from '../services/upload-listing-import-source';
import { postListingImportJson } from '../utils/post-listing-import-json';
interface ListingImportUploadInput {
  orgId: string;
  file: File;
  importId: string;
  onPhase?: (phase: 'preparing' | 'uploading' | 'committing') => void;
}
export function useListingImportUpload() {
  const $ = _c(2);
  const supabase = useSupabaseClient();
  let t0;
  if ($[0] !== supabase) {
    t0 = {
      mutationFn: async t1 => {
        const {
          orgId,
          file,
          importId,
          onPhase
        } = t1;
        onPhase?.("preparing");
        await postListingImportJson("/api/listings/upload/init", {
          idempotencyKey: importId
        }, "Init failed");
        onPhase?.("uploading");
        await uploadListingImportSource({
          supabase,
          storagePath: `${orgId}/${importId}/source.csv`,
          file
        });
        onPhase?.("committing");
        const committed = await postListingImportJson("/api/listings/upload/commit", {
          importId
        }, "Commit failed");
        return {
          importId: committed.importId
        };
      }
    };
    $[0] = supabase;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}